import { render, staticRenderFns } from "./OverlayIcon.vue?vue&type=template&id=3d355b93&scoped=true"
import script from "./OverlayIcon.vue?vue&type=script&lang=js"
export * from "./OverlayIcon.vue?vue&type=script&lang=js"
import style0 from "./OverlayIcon.vue?vue&type=style&index=0&id=3d355b93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d355b93",
  null
  
)

export default component.exports